import React from 'react';

import Store, { history } from 'data/Store'
import { logout } from 'data/app/App.actions'

class Logout extends React.Component {
    componentDidMount() {
        Store.dispatch(logout())
        setTimeout(() => history.replace({ pathname: '/login' }));
    }

    render() {
        return <div />
    }
}

export default Logout;